export default __webpack_public_path__ + "static/media/astronaut.84a31d13.png";